import { Store } from '@betgames/bg-state-manager';
import { IMessage } from './interfaces';

export default class GameMessageStore extends Store<IMessage[]> {
    constructor() {
        super({
            key: 'GameMessage',
            default: [],
        });
    }

    public add = (message: IMessage) => {
        this.update((draft) => {
            draft.push(message);
        });
    };
}
